import script from "./keyword-search-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./keyword-search-dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__